import React from 'react';
import PropTypes from 'prop-types';

import styles from './simple_radio_button.css';

const SimpleRadioButton = (props) => {
    const { label, value, identifier, checked } = props;
    const elementId = `${identifier}.${value}`;
    const labelClassName = checked ? styles.radioButton__label__checked : styles.radioButton__label;

    /**
   * Handles the on change method
   * @param {Event} event - the on change event
   */
    const onChange = (event) => {
        props.onChange(event, props.value);
    };

    /**
     * Renders the SimpleRadioButton
     * @returns {Node} - returns the SimpleRadioButton component
     */
    return (
        <label
            className={labelClassName}
            htmlFor={elementId}>
            <input
                type="radio"
                className={styles.radioButton__input}
                onChange={onChange}
                checked={checked}
                name={identifier}
                value={value}
                id={elementId}
                data-id={elementId}
            />
            {label}
        </label>
    );
};

SimpleRadioButton.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired
};

export default SimpleRadioButton;
